import React, { memo, useMemo, useState } from "react";
import { map, get } from "lodash";
import ModalMenu from "components/Modals";
import FillBlanksPreview from "../fillBlanksPreview";
import styled from "styled-components";
import ReactPlayer from "react-player";
import usePermissionForUser from "components/hooks/permissions/usePermissionForUser";
import TranscriptWithAudio from "components/UI/transcriptWithAudio/transcriptWithAudio";
import { resolveMediaUrl } from "utils/methods/assignmentTranscripts";

const GradeDisplayPreviewComponent = ({
  question,
  index,
  answer,
  isStudent,
  neutral = false,
  transcripts = {},
}) => {
  const [openImageFillBlanks, setImageFillBlanks] = useState({});

  const handleImageClick = (open, index, optionIndex) => {
    setImageFillBlanks({
      open: open,
      questionIndex: index,
      optionIndex: optionIndex,
    });
  };

  const { districtPermissionConfig } = usePermissionForUser();
  const { audio_download= false } = useMemo(() => {
    return districtPermissionConfig
  }, [districtPermissionConfig])

  return (
    <>
      {map(get(question, "options", [""]), (option, optId) => (
        <div style={{ paddingInline: "4px" }} className="mb-10px">
          <div>
            {!isStudent && (
              <div>
                <Question index={index}>
                  Answer Key {optId + 1} of {question?.options?.length}
                </Question>
                <FillBlanksPreview
                  isAssignmentReview={true}
                  isGradePreview={true}
                  text={option}
                  highlights={
                    (question?.highlightWords &&
                      question.highlightWords[optId]) ||
                    []
                  }
                  answerOption={
                    (question?.answerSelected &&
                      question.answerSelected[optId]) ||
                    []
                  }
                  selected_answer={
                    question.highlightWords && question?.highlightWords[optId]
                  }
                  isStudent={isStudent}
                  questionPreview={true}
                />
              </div>
            )}

            {question.type === "fillingImage" || question.fillingType === "Image" && (
              <>
                <ModalMenu
                  type="imageModal"
                  image={
                    question?.filling_image &&
                    question?.filling_image[optId]?.url
                  }
                  open={
                    (openImageFillBlanks?.open &&
                      openImageFillBlanks?.questionIndex === index &&
                      openImageFillBlanks?.optionIndex === optId) ||
                    false
                  }
                  close={() => setImageFillBlanks({})}
                />
                {(question?.filling_image && question?.filling_image[optId]?.url) && 
                <>
                <img
                  src={
                    question?.filling_image &&
                    question?.filling_image[optId]?.url
                  }
                  alt={`Match ${optId}`}
                  draggable={false}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "8px",
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleImageClick(true, index, optId);
                  }}
                />
                </>
                }
                
              </>
            )}
            {question.fillingType === 'Audio' && (
              <>
              {(question?.filling_image && question?.filling_image[optId]?.url) && (<TranscriptWithAudio
                audioUrl={resolveMediaUrl(question?.filling_image?.[optId])}
                transcripts={transcripts}
              >
                <ReactPlayer
                  url={question?.filling_image && question?.filling_image[optId]?.url}
                  height="40px"
                  width="100%"
                  controls
                  playsinline
                  style={{ marginBottom: '8px', marginTop: '10px' }}
                  config={{ file: { forceAudio: true, attributes: { controlsList: "nodownload" } } }}
                />
              </TranscriptWithAudio>
              )}
              </>
            )}
          </div>
          <ImageAnswerArea style={{ marginTop: "40px" }}>
            <AnswerMarkLagendaArea>Answer {optId + 1} of {question?.options?.length}</AnswerMarkLagendaArea>
            <div index={index} className="mb-10px">
              <FillBlanksPreview
                isAssignmentReview={false}
                text={option}
                highlights={
                  (question?.highlightWords &&
                    question.highlightWords[optId]) ||
                  []
                }
                answerOption={
                  (question?.answerSelected &&
                    question.answerSelected[optId]) ||
                  []
                }
                selected_answer={
                  answer?.selected_answer && answer?.selected_answer[optId]
                }
                neutral={neutral}
              />
            </div>
          </ImageAnswerArea>
        </div>
      ))}
    </>
  );
};

export default memo(GradeDisplayPreviewComponent);

const Question = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  align-items: center;
  display: flex;
`;

const ImageAnswerArea = styled.div`
  display : flex;
  flex-direction: column;
  col-gap:10px;
  row-gap:10px;
  border: 1px dashed black;
  margin-top: 15px;
  padding: 10px;
  position: relative;
}
`;

const AnswerMarkLagendaArea = styled.div`
  position: absolute;
  left: 10px;
  background-color: white;
  top: -12px;
  padding-left: 5px;
  padding-right: 5px;
`;
